import * as React from "react"
import type { SVGProps } from "react"
const SvgCreditCard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M22 6.43v12q0 .83-.59 1.41a2 2 0 0 1-1.41.59H4q-.82 0-1.41-.59A2 2 0 0 1 2 18.43v-12q0-.82.59-1.41A2 2 0 0 1 4 4.42h16q.83 0 1.41.6.6.59.59 1.4m-18 2h16v-2H4zm0 4v6h16v-6z" />
  </svg>
)
export default SvgCreditCard
